import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14 7c0 1.792-.842 3.418-2 4.5l-4 4-4-4C2.815 10.334 2 8.792 2 7a6 6 0 1 1 12 0M8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
		clipRule: "evenodd"
	})
});
export default SvgLocationAlt;
